var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import classNames from 'clsx';
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
import Popover from '../popover';
import { Styled, StyledPopoverContent } from './style';
export var MultilineTagInputAction;
(function (MultilineTagInputAction) {
    MultilineTagInputAction["Add"] = "Add";
    MultilineTagInputAction["Remove"] = "Remove";
})(MultilineTagInputAction || (MultilineTagInputAction = {}));
var MultilineTagInput = /** @class */ (function (_super) {
    __extends(MultilineTagInput, _super);
    function MultilineTagInput(props) {
        var _this = _super.call(this, props) || this;
        _this.applyValue = function (event) {
            var values = _this.props.values;
            var isValidValue = _this.props.validateValue ? _this.props.validateValue(event.target.value.trim()) : true;
            var newValue = { value: event.target.value, isValidValue: isValidValue };
            _this.props.callback({
                currentValue: newValue,
                values: __spreadArrays(values, [newValue]),
                value: event.target.value,
            }, MultilineTagInputAction.Add);
            event.target.value = isValidValue ? '' : event.target.value;
        };
        _this.onKeypress = function (event) {
            var values = _this.props.values;
            var remainingValue = _this.state.remainingValue;
            if (event.key === 'Enter' && event.target.value !== '') {
                _this.applyValue(event);
            }
            else if (event.key === 'Backspace' && values.length > 0 && remainingValue.length === 0) {
                _this.removeValue(values.length - 1);
            }
            _this.setState({ remainingValue: event.target.value });
            return;
        };
        _this.removeValue = function (index) {
            var values = _this.props.values;
            _this.props.callback({ values: __spreadArrays(values.filter(function (item) { return values.indexOf(item) !== index; })) }, MultilineTagInputAction.Remove);
        };
        _this.removeValues = function () {
            _this.props.callback({ values: [] }, MultilineTagInputAction.Remove);
        };
        _this.onBlur = function (event) {
            if (event.target.value !== '') {
                _this.applyValue(event);
            }
            _this.setState({ remainingValue: '' });
        };
        _this.state = {
            remainingValue: '',
        };
        return _this;
    }
    MultilineTagInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoFocus = _a.autoFocus, currentValue = _a.currentValue, disabled = _a.disabled, values = _a.values, value = _a.value, warning = _a.warning, forwardRef = _a.forwardRef, isLog = _a.isLog;
        var placeholder = values.length === 0 ? this.props.placeholder || 'Press enter to add values' : '';
        return (React.createElement(Styled, null,
            isLog && React.createElement("div", { className: "log-search-icon" },
                React.createElement(Icon, { name: "search" })),
            values.map(function (item, index) { return (item.isValidValue && (React.createElement("div", { key: index, className: classNames('value', { 'first-value': (isLog && index === 0) }) },
                item.value,
                React.createElement("i", { className: "close", onClick: function () { return _this.removeValue(index); } })))); }),
            !currentValue || (currentValue && currentValue.isValidValue) || value === '' || values.length === 0 ? (React.createElement("input", { type: "text", onKeyUp: function (event) { return _this.onKeypress(event); }, placeholder: placeholder, autoFocus: autoFocus || values.length > 0, onChange: function (event) { return _this.props.onChange(event); }, onBlur: function (event) { return _this.onBlur(event); }, ref: forwardRef, disabled: disabled })) : (React.createElement(Popover, { style: { marginTop: '-3px' }, trigger: React.createElement("input", { type: "text", value: this.props.value, onChange: function (event) { return _this.props.onChange(event); }, onKeyUp: function (event) { return _this.onKeypress(event); }, onBlur: function (event) { return _this.onBlur(event); }, placeholder: placeholder, autoFocus: true }), content: React.createElement(StyledPopoverContent, null,
                    React.createElement(Icon, { name: "warning" }),
                    React.createElement("div", null, warning || 'Invalid Value.')), position: "bottom left", open: true })),
            isLog && values.length > 0 && React.createElement("div", { className: "clear-tags" },
                React.createElement(Button, { icon: true, onClick: this.removeValues },
                    React.createElement(Icon, { name: "close" })))));
    };
    return MultilineTagInput;
}(React.Component));
export default MultilineTagInput;
//# sourceMappingURL=index.js.map